import React from 'react'
import Navbar from "../components/Navbar/Navbar"
import Coursecontentlist from '../components/courseContent/Coursecontentlist'

const courseContentPageList = () => {
  return (
    <>
    <Navbar/>
    <Coursecontentlist/>
    </>

  )
}

export default courseContentPageList